const typography = {
    TinyParagraph: {
        fontFamily: "Inter, sans-serif",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "17px",
        letterSpacing: "normal"
    },
    Paragraph: {
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "27px",
        letterSpacing: "normal"
    },
    LargeParagraph: {
        fontFamily: "Inter, sans-serif",
        fontSize: "24px",
        fontWeight: 400,
        lineHeight: "35px",
        letterSpacing: "normal"
    },
    SmallCapsHeadline: {
        fontFamily: "Inter, sans-serif",
        fontSize: "12px",
        fontWeight: 800,
        lineHeight: "15px",
        letterSpacing: "0.1em",
        textTransform: "uppercase"
    },
    SmallHeadline: {
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        fontWeight: 800,
        lineHeight: "19px",
        letterSpacing: "normal"
    },
    Subheadline: {
        fontFamily: "Inter, sans-serif",
        fontSize: "24px",
        fontWeight: 800,
        lineHeight: "26px",
        letterSpacing: "normal"
    },
    Headline: {
        fontFamily: "Inter, sans-serif",
        fontSize: "36px",
        fontWeight: 800,
        lineHeight: "39px",
        letterSpacing: "-0.01em"
    },
    SuperHeadline: {
        fontFamily: "Inter, sans-serif",
        fontSize: "48px",
        fontWeight: 800,
        lineHeight: "52px",
        letterSpacing: "-0.01em"
    },
    HugeHeadline: {
        fontFamily: "Inter, sans-serif",
        fontSize: "80px",
        fontWeight: 900,
        lineHeight: "77px",
        letterSpacing: "-0.03em"
    }
};
var typography$1 = typography;

export { typography$1 as default };
